import { FC, useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector, useTranslate } from 'hooks';

import { Paper } from 'componets/ui';
import { RegistrationLayout } from 'componets/layouts';

import { AccountService } from 'api';

import { Paths } from 'utils/constants';

import { selectUser } from 'selectors';

import { ReactComponent as VeriffLogo } from 'assets/images/veriff.svg';
import { ReactComponent as DotsLoader } from 'assets/images/dots.svg';

import styles from '../Register/index.module.scss';

type LocationState = {
	fromOverview?: boolean;
};

export const VerifyIdentity: FC = () => {
	const {
		verifyLaterText,
		verifyIdentityText,
		verifyIdentity2Text,
		verifyMyIdentityText,
		verifyIdentity4Text,
		skipForText,
		verifyIdentity5Text,
	} = useTranslate([
		'verifyLaterText',
		'verifyIdentityText',
		'verifyIdentity2Text',
		'verifyMyIdentityText',
		'verifyIdentity4Text',
		'verifyIdentity5Text',
		'skipForText',
	]);

	const user = useAppSelector(selectUser);

	const location = useLocation();

	const navigate = useNavigate();

	const [isRedirect, setIsRedirect] = useState(false);

	useEffect(() => {
		return () => setIsRedirect(false);
	}, []);

	const onClick = async () => {
		const result: any = await AccountService.verify();
		setIsRedirect(true);
		const link = result?.verification_link;
		window.open(link, '_self');
	};

	const state = location.state as LocationState;

	const verifyLaterLink = state?.fromOverview ? Paths.OVERVIEW : Paths.RESIDENCY;

	return (
		<RegistrationLayout email={user.email} fromOverview={state?.fromOverview}>
			<Paper styleName={styles.blockForm} top={isRedirect ? <DotsLoader /> : <></>}>
				<Typography.Title level={4} className={styles.veriffTitle}>
					{isRedirect ? verifyIdentity4Text : verifyIdentityText}
				</Typography.Title>
				<Typography.Text className={styles.veriffText}>
					{isRedirect ? verifyIdentity5Text : verifyIdentity2Text}
				</Typography.Text>
				{isRedirect ? (
					<Button type="ghost" block onClick={() => navigate('/account')}>
						{skipForText}
					</Button>
				) : (
					<Button type="primary" size="large" block onClick={onClick}>
						{verifyMyIdentityText}
					</Button>
				)}

				<VeriffDescription />
			</Paper>

			{!isRedirect && (
				<div className={styles.verifyLater} role="button" onClick={() => navigate(verifyLaterLink)}>
					<Typography.Text type="secondary">{verifyLaterText}</Typography.Text>
				</div>
			)}
		</RegistrationLayout>
	);
};

const VeriffDescription: FC = () => {
	const { verifyIdentity3Text } = useTranslate(['verifyIdentity3Text']);

	return (
		<div className={styles.veriffDescription}>
			<div className={styles.icon}>
				<VeriffLogo />
			</div>
			<div className={styles.text}>
				<Typography.Text type="secondary">{verifyIdentity3Text}</Typography.Text>
			</div>
		</div>
	);
};
